import { Skeleton, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import Paper from '@mui/material/Paper';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux';
import { useMemo } from 'react';
import { useCalculation } from './testCalculation.hook';
interface IShowFormulaResultProps {
  orderedListOfFlows: string[];
  propKey: string;
  url: string;
  calculationName: string;
}
const ShowFormulaResult = ({
  orderedListOfFlows,
  propKey,
  url,
  calculationName,
}: IShowFormulaResultProps) => {
  const calculations = useSelector((state: RootState) => state.calculations);
  const currentCalculationSession = useMemo(
    () => calculations.properties[propKey]?.currentCalculationSession,
    [propKey],
  );
  const { result, loading, error } = useCalculation(
    orderedListOfFlows,
    currentCalculationSession!.calculationInfo,
    calculationName,
    url,
  );

  const lastFlowId = orderedListOfFlows[orderedListOfFlows.length - 1];
  const flowInfo = currentCalculationSession?.calculationInfo.flows[lastFlowId];
  const dataType =
    flowInfo?.[0].flow === 'IfElse'
      ? currentCalculationSession?.calculationInfo.selectedResultType[lastFlowId]
      : flowInfo?.[0].resultantDatatype;

  const getOption = (value: string | number | null) => {
    if (value === null) return '(Blank)';
    if (value === '') return '(Empty)';

    if (dataType === 'boolean') return ['TRUE', 'true', '1', 1, true].includes(value) ? 'True' : 'False';
    return String(value);
  };
  if (error) {
    return (
      <div style={{ color: 'red', margin: '20px 10px' }}>
        Something went wrong. Please try again later.
      </div>
    );
  }

  return (
    <div>
      <TableContainer style={{ width: '200px', margin: ' auto' }} component={Paper}>
        <Table aria-label="simple table">
          <TableBody>
            {loading
              ? Array.from(new Array(5)).map((_, index) => {
                  return (
                    <TableRow key={index}>
                      <Skeleton sx={{ fontSize: '1.3rem' }} variant="text" />
                    </TableRow>
                  );
                })
              : result?.datas.map((data, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell
                        sx={{
                          padding: '4px',
                        }}
                      >
                        {getOption(data[result.key])}
                      </TableCell>
                    </TableRow>
                  );
                })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ShowFormulaResult;

